import React from 'react';
import styles from './StatsGrid.module.css';

interface StatItem {
    value: number;
    label: string;
    description?: string;
}

interface StatsGridProps {
    stats: StatItem[];
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
    // Фразы для описаний
    const descriptions = [
        "И это только начало! 🚀",
        "Скоро будет больше! 📈",
        "Невероятные результаты! 🔥",
        "Потрясающе! 😮",
        "Коллеги в восторге! 👏"
    ];

    return (
        <div className={styles.statsGrid}>
            {stats.map((stat, index) => (
                <div key={index} className={styles.statCard}>
                    <div className={styles.statValue}>{stat.value}</div>
                    <div className={styles.statLabel}>{stat.label}</div>
                    <div className={styles.statDescription}>
                        {stat.description || descriptions[Math.floor(Math.random() * descriptions.length)]}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StatsGrid;